// What To Expect
import Pillar1 from "assets/breakfast-event/what-to-expect/image1.png";
import Pillar2 from "assets/breakfast-event/what-to-expect/image2.png";
import Pillar3 from "assets/breakfast-event/what-to-expect/image3.png";
import Pillar4 from "assets/breakfast-event/what-to-expect/image4.png";
import Pillar5 from "assets/breakfast-event/what-to-expect/image5.png";
import Topic1 from "assets/breakfast-event/what-to-expect/topic1.svg";
import Topic2 from "assets/breakfast-event/what-to-expect/topic2.svg";
import Topic3 from "assets/breakfast-event/what-to-expect/topic3.svg";
import Topic4 from "assets/breakfast-event/what-to-expect/topic4.svg";
import Topic5 from "assets/breakfast-event/what-to-expect/topic5.svg";

// Speakers
import Speaker1 from "assets/breakfast-event/speakers/speaker-1.png";
import Speaker2 from "assets/breakfast-event/speakers/speaker-2.png";
import Speaker3 from "assets/breakfast-event/speakers/speaker-3.png";
import Speaker4 from "assets/breakfast-event/speakers/speaker-4.png";
import Speaker5 from "assets/breakfast-event/speakers/speaker-5.png";
import Speaker6 from "assets/breakfast-event/speakers/speaker-6.png";
import Speaker7 from "assets/breakfast-event/speakers/speaker-7.png";
import Speaker8 from "assets/breakfast-event/speakers/speaker-8.png";
import Speaker9 from "assets/breakfast-event/speakers/speaker-9.png";
import Speaker10 from "assets/breakfast-event/speakers/speaker-10.jpeg";
import Speaker11 from "assets/breakfast-event/speakers/speaker-11.jpeg";
import Speaker12 from "assets/breakfast-event/speakers/speaker-12.jpeg";

// GALLERY
import Image1 from "assets/breakfast-event/breakfast-image/image1.png";
import Image2 from "assets/breakfast-event/breakfast-image/image2.png";
import Image3 from "assets/breakfast-event/breakfast-image/image3.png";
import Image4 from "assets/breakfast-event/breakfast-image/image4.png";
import Image5 from "assets/breakfast-event/breakfast-image/image5.png";
import Image6 from "assets/breakfast-event/breakfast-image/image6.png";
import Image7 from "assets/breakfast-event/breakfast-image/image7.png";

export const PROGRAM_PILLARS = [Pillar1, Pillar2, Pillar3, Pillar4, Pillar5];

export const AWARDS_ENGLISH = [
  {
    title: "Digital Trust Leadership",
    eligibility: "Tier 1, Tier 2 & Tier 3 Financial Institutions, Fintechs",
    description:
      "This award recognises an institution that has demonstrated exceptional leadership in embedding digital trust across its operations through robust cybersecurity frameworks, responsible data governance, and customer-centric digital practices.",
  },
  {
    title: "Cyber Resilience Excellence",
    eligibility: "Financial Institutions, Fintechs",
    description:
      "Awarded to organisations that have shown strong preparedness and resilience against cyber threats, with the ability to prevent, withstand, and recover from cyber incidents while ensuring service continuity.",
  },
  {
    title: "Compliance and Governance Excellence",
    eligibility: "Financial Institutions, Fintechs, Regulatory Bodies",
    description:
      "This award recognises institutions that demonstrate excellence in regulatory compliance, governance, and risk management, embedding compliance seamlessly into business processes.",
  },
  {
    title: "Data Privacy and Protection Champion",
    eligibility: "Financial Institutions, Fintechs",
    description:
      "Recognises organisations that have implemented exemplary data privacy and protection practices, ensuring transparency, consent, and strong safeguards for customer information.",
  },
  {
    title: "Secure Innovatio",
    eligibility: "Fintechs, Digital Banks, Financial Institutions",
    description:
      "Awarded to organisations that have successfully launched innovative digital products or services while maintaining strong security, compliance, and risk controls.",
  },
  {
    title: "Regulatory Leadership & Industry Stewardship",
    eligibility: "Regulatory Bodies, Industry Associations",
    description:
      "his award honours regulators or industry bodies that have demonstrated leadership in developing policies, frameworks, or initiatives that strengthen digital trust and financial stability.",
  },
  {
    title: "Emerging Institution in Digital Trust Award",
    eligibility:
      "Tier 2 & Tier 3 Financial Institutions, Growth-stage Fintechs",
    description:
      "Recognises fast-growing organisations that are proactively embedding cybersecurity, compliance, and trust frameworks early in their growth journey.",
  },
  {
    title: "Industry Impact Award for Digital Trust",
    eligibility: "Tier 1, Tier 2 & Tier 3 Financial Institutions, Fintechs",
    description:
      "Awarded to an organisation whose initiatives or leadership have had a measurable, positive impact on improving digital trust across the Kenyan financial services ecosystem.",
  },
  {
    title: " Lifetime Contribution to Digital Trust (Kenya) (Honorary Award)",
    eligibility:
      "Regulatory leaders, industry pioneers, technology or financial services veterans",
    description:
      "This honorary award recognises an individual whose career-long contributions have significantly advanced cybersecurity, compliance, data protection, and digital trust within Kenya’s financial ecosystem.",
  },
];
export const AWARDS_FRENCH = [
  {
    title: "Prix du Leadership en Confiance Numérique",
    eligibility: "Institutions financières de niveau 1, 2 et 3, Fintechs",
    description:
      "Ce prix récompense une institution ayant démontré un leadership exceptionnel dans l'intégration de la confiance numérique à l'ensemble de ses opérations grâce à des cadres robustes de cybersécurité, une gouvernance responsable des données et des pratiques numériques centrées sur le client.",
  },
  {
    title: "Prix d'Excellence en Résilience Cyber",
    eligibility: "Institutions financières, Fintechs",
    description:
      "Décerné aux organisations ayant montré une forte préparation et résilience face aux menaces cybernétiques, avec la capacité de prévenir, résister et se remettre des incidents cyber tout en assurant la continuité des services.",
  },
  {
    title: "Prix d'Excellence en Conformité et Gouvernance",
    eligibility: "Institutions financières, Fintechs, Organismes de régulation",
    description:
      "Ce prix récompense les institutions qui font preuve d'excellence en matière de conformité réglementaire, de gouvernance et de gestion des risques, intégrant la conformité de manière fluide dans les processus opérationnels.",
  },
  {
    title: "Prix du Champion de la Confidentialité et Protection des Données",
    eligibility: "Institutions financières, Fintechs",
    description:
      "Reconnaît les organisations ayant mis en œuvre des pratiques exemplaires de confidentialité et de protection des données, garantissant transparence, consentement et solides mesures de sécurité pour les informations des clients.",
  },
  {
    title: "Prix de l'Innovation Sécurisée",
    eligibility: "Fintechs, Banques digitales, Institutions financières",
    description:
      "Décerné aux organisations ayant lancé avec succès des produits ou services numériques innovants tout en maintenant des contrôles rigoureux en matière de sécurité, de conformité et de gestion des risques.",
  },
  {
    title: "Prix du Leadership Réglementaire et de la Gouvernance Industrielle",
    eligibility: "Organismes de régulation, Associations professionnelles",
    description:
      "Ce prix honore les régulateurs ou organismes industriels ayant démontré un leadership dans le développement de politiques, cadres ou initiatives renforçant la confiance numérique et la stabilité financière.",
  },
  {
    title: "Prix de l'Institution Émergente en Confiance Numérique",
    eligibility:
      "Institutions financières de niveau 2 et 3, Fintechs en croissance",
    description:
      "Reconnaît les organisations en forte croissance qui intègrent de manière proactive la cybersécurité, la conformité et les cadres de confiance dès les premières étapes de leur développement.",
  },
  {
    title: "Prix de l'Impact Industriel sur la Confiance Numérique",
    eligibility: "Institutions financières de niveau 1, 2 et 3, Fintechs",
    description:
      "Décerné à une organisation dont les initiatives ou le leadership ont eu un impact mesurable et positif sur l'amélioration de la confiance numérique dans l'écosystème des services financiers kényan.",
  },
  {
    title: "Prix Honorifique de Contribution à la Confiance Numérique (Kenya)",
    eligibility:
      "Leaders réglementaires, pionniers de l'industrie, vétérans de la technologie ou des services financiers",
    description:
      "Ce prix honorifique reconnaît un individu dont les contributions tout au long de sa carrière ont significativement fait progresser la cybersécurité, la conformité, la protection des données et la confiance numérique au sein de l'écosystème financier du Kenya.",
  },
];

export const WHAT_TO_EXPECT_ENGLISH = [
  {
    image: Pillar1,
    topic: Topic1,
    title: "Keynotes",
    description:
      "Two perspective-shifting talks on AI-ready security, privacy, and resilience in African finance.",
  },
  {
    image: Pillar2,
    topic: Topic2,
    title: "Panels",
    description:
      "Leaders from banks, telcos, regulators, and fintechs on what actually works and what does not.",
  },
  {
    image: Pillar3,
    topic: Topic3,
    title: "Demos",
    description:
      "Live walkthroughs of Smartcomply’s product suite: Seequre, Adhere, Oculus, Academy. See controls, workflows, and dashboards in action.",
  },
  {
    image: Pillar4,
    topic: Topic4,
    title: "Research",
    description:
      "Launch of our joint Desktop Research Report: Five Insights, Three Charts, One Executive Checklist for 2026.",
  },
  {
    image: Pillar5,
    topic: Topic5,
    title: "Awards",
    description:
      "A short recognition moment celebrating practitioners and programs advancing cyber maturity in East Africa.",
  },
];

export const WHAT_TO_EXPECT_FRENCH = [
  {
    image: Pillar1,
    topic: Topic1,
    title: "Discours principaux",
    description:
      "Deux conférences qui changent de perspective sur la sécurité, la confidentialité et la résilience adaptées à l’IA dans la finance africaine.",
  },
  {
    image: Pillar2,
    topic: Topic2,
    title: "Tables rondes",
    description:
      "Des dirigeants de banques, de télécoms, de régulateurs et de fintechs sur ce qui fonctionne réellement et ce qui ne fonctionne pas.",
  },
  {
    image: Pillar3,
    topic: Topic3,
    title: "Démonstrations",
    description:
      "Présentations en direct de la suite de produits Smartcomply : Seequre, Adhere, Oculus, Academy. Découvrez les contrôles, les flux de travail et les tableaux de bord en action.",
  },
  {
    image: Pillar4,
    topic: Topic4,
    title: "Recherche",
    description:
      "Lancement de notre rapport de recherche Desktop conjoint : Cinq enseignements, trois graphiques, une checklist exécutive pour 2026.",
  },
  {
    image: Pillar5,
    topic: Topic5,
    title: "Prix",
    description:
      "Un court moment de reconnaissance célébrant les praticiens et les programmes qui font progresser la maturité en cybersécurité en Afrique de l’Est.",
  },
];

export const LATEST_GALLERY = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
];
export const SPEAKERS_ENGLISH = [
  {
    image: Speaker1,
    name: "DR. VINCENT OLATUNJI",
    description:
      "National Commissioner/CEO Nigeria Data Protection Commission , [NDPC]",
    topic:
      "From Data to Defense: Turning Privacy, Compliance and Threat Intelligence into Customer Trust",
  },
  {
    image: Speaker6,
    name: "IMMACULATE KASSAIT, SC, MBS",
    description:
      "Data Commissioner, Office of the Data Protection Commission, Kenya",
    topic:
      "Fireside Chat Topic: Building Digital Trust at Scale: Lessons from Kenya and Nigeria’s Data Protection Journeys",
  },
  {
    image: Speaker2,
    name: "CP UCHE IFEANYI HENRY",
    description:
      "Commissioner of Police Director, Nigeria Police National Cybercrime Centre, [NPF - NCCC]",
    topic:
      "Five Hard Truths About AI and Cyber in African Finance (2026 Outlook)",
  },
  {
    image: Speaker12,
    name: "JANINE MUKA-MUASYA",
    description: "Head of Infosecurity, Cellulant",
    topic:
      "Panel Session Topic: From Reactive Defense to Proactive Resilience: Rethinking Cybersecurity in Africa",
  },
  {
    image: Speaker7,
    name: "WILSON GITAU",
    description:
      "Manager, Cybersecurity Architecture and Assurance, M-Pesa Africa",
    topic: "AI & the Cyber Frontier: Securing East Africa’s Digital Future",
  },
  {
    image: Speaker11,
    name: "GBEMISOLA OSUNRINDE",
    description: "CEO, Smartcomply",
    topic:
      "Fireside Chat Topic: Building Digital Trust at Scale: Lessons from Kenya and Nigeria’s Data Protection Journeys",
  },
  {
    image: Speaker8,
    name: "BEN NGUNJIRI",
    description: "Technology Sector Representative, DPGSK",
    topic: "AI & the Cyber Frontier: Securing East Africa’s Digital Future",
  },
  {
    image: Speaker10,
    name: "CHARITY MURIGI MUGAMBI",
    description: "Head, Group Communications and Brand, Cellulant",
    topic:
      "Panel Session Topic: From Reactive Defense to Proactive Resilience: Rethinking Cybersecurity in Africa",
  },
  {
    image: Speaker9,
    name: "KENN ABUJA",
    description: "Senior Reporter, TechCabal",
    topic: "AI & the Cyber Frontier: Securing East Africa’s Digital Future",
  },
  {
    image: Speaker4,
    name: "MR. DANIEL OBOT",
    description: "Div CEO,Seequre",
    topic:
      "Panel Session Topic: From Reactive Defense to Proactive Resilience: Rethinking Cybersecurity in Africa",
  },
  {
    image: Speaker5,
    name: "LINET APIYO",
    description: "Senior Consultant, Smartcomply",
    topic: "AI & the Cyber Frontier: Securing East Africa’s Digital Future.",
  },
  {
    image: Speaker3,
    name: "MR. FEYIJIMI ADEWOLE",
    description:
      "Chief Information Security Officer (CISO) and Data Protection Officer (DPO), [Coronation Merchant Bank]",
    topic:
      "Panel Session Topic: From Reactive Defense to Proactive Resilience: Rethinking Cybersecurity in Africa",
  },
];
export const SPEAKERS_FRENCH = [
  {
    image: Speaker1,
    name: "DR. VINCENT OLATUNJI",
    description:
      "Commissaire national / PDG, Commission nigériane de protection des données [NDPC]",
    topic:
      "Des données à la défense : transformer la confidentialité, la conformité et le renseignement sur les menaces en confiance client",
  },
  {
    image: Speaker6,
    name: "IMMACULATE KASSAIT, SC, MBS",
    description:
      "Commissaire aux données, Bureau de la Commission de protection des données, Kenya",
    topic:
      "Sujet du Fireside Chat : Construire la confiance numérique à grande échelle : enseignements tirés des parcours de protection des données",
  },
  {
    image: Speaker2,
    name: "CP UCHE IFEANYI HENRY",
    description:
      "Commissaire de police, Directeur du Centre national de lutte contre la cybercriminalité de la Police nigériane [NPF - NCCC]",
    topic:
      "Cinq dures réalités sur l’IA et la cybersécurité dans la finance africaine (Perspectives 2026)",
  },
  {
    image: Speaker12,
    name: "JANINE MUKA-MUASYA",
    description: "Responsable de la sécurité de l'information, Cellulant",
    topic:
      "Thème de la session panel : De la défense réactive à la résilience proactive : repenser la cybersécurité en Afrique",
  },
  {
    image: Speaker7,
    name: "WILSON GITAU",
    description:
      "Responsable, Architecture et Assurance en Cybersécurité, M-Pesa Afrique",
    topic:
      "IA et la frontière cybernétique : sécuriser l’avenir numérique de l’Afrique de l’Est",
  },
  {
    image: Speaker11,
    name: "GBEMISOLA OSUNRINDE",
    description: "PDG, Smartcomply",
    topic:
      "Thème de discussion informelle : bâtir la confiance numérique à grande échelle : leçons des parcours de protection des données du Kenya et du Nigeria",
  },
  {
    image: Speaker8,
    name: "BEN NGUNJIRI",
    description: "Représentant du secteur technologique, DPGSK",
    topic:
      "IA et la frontière cybernétique : sécuriser l’avenir numérique de l’Afrique de l’Est",
  },
  {
    image: Speaker10,
    name: "CHARITY MURIGI MUGAMBI",
    description: "Responsable, Communications de Groupe et Marque, Cellulant",
    topic:
      "Sujet de la session de panel: De la défense réactive à la résilience proactive : repenser la cybersécurité en Afrique",
  },
  {
    image: Speaker9,
    name: "KENN ABUJA",
    description: "Journaliste principal, TechCabal",
    topic:
      "IA et la frontière cybernétique : sécuriser l’avenir numérique de l’Afrique de l’Est",
  },

  {
    image: Speaker4,
    name: "MR. DANIEL OBOT",
    description: "Directeur de division (Div CEO), Seequre",
    topic:
      "Sujet de la session de panel: De la défense réactive à la résilience proactive : repenser la cybersécurité en Afrique",
  },
  {
    image: Speaker5,
    name: "LINET APIYO",
    description: "Senior Consultant, Smartcomply",
    topic:
      "IA et la frontière cybernétique : sécuriser l’avenir numérique de l’Afrique de l’Est",
  },
  {
    image: Speaker3,
    name: "MR. FEYIJIMI ADEWOLE",
    description:
      "Directeur de la sécurité des systèmes d’information (CISO) et Délégué à la protection des données (DPO), [Coronation Merchant Bank]",
    topic:
      "Sujet de la session de panel: De la défense réactive à la résilience proactive : repenser la cybersécurité en Afrique",
  },
];

export const AGENDAS_ENGLISH = [
  {
    start_time: "07:00AM",
    end_time: "07:45AM",
    activity: "Arrival & Registration",
    type: "morning",
  },
  {
    start_time: "07:45AM",
    end_time: "07:50AM",
    activity: "House Rules & Safety",
    type: "morning",
  },
  {
    start_time: "07:50AM",
    end_time: "07:53AM",
    activity: "National Anthem",
    type: "morning",
  },
  {
    start_time: "07:53AM",
    end_time: "08:00AM",
    activity: "Opening Remarks",
    type: "morning",
  },
  {
    start_time: "08:00AM",
    end_time: "08:20AM",
    activity: "Keynote 1: The Secure Horizon",
    type: "morning",
  },
  {
    start_time: "08:20AM",
    end_time: "08:50AM",
    activity: "Fireside Chat",
    type: "morning",
  },
  {
    start_time: "08:50AM",
    end_time: "09:00AM",
    activity: "Intermission / Transition",
    type: "morning",
  },
  {
    start_time: "09:00AM",
    end_time: "09:40AM",
    activity: "Panel 1: AI, Real-Time Finance & Trust",
    type: "morning",
  },
  {
    start_time: "09:40AM",
    end_time: "10:00AM",
    activity: "Tea Break & Networking",
    type: "morning",
  },
  {
    start_time: "10:00AM",
    end_time: "10:20AM",
    activity: "Keynote 2: From Data to Defense",
    type: "morning",
  },
  {
    start_time: "10:20AM",
    end_time: "10:25AM",
    activity: " Intermission / Reset",
    type: "morning",
  },
  {
    start_time: "10:25AM",
    end_time: "11:05AM",
    activity: "Panel 2: Research Unveiling + Reactions Panel",
    type: "morning",
  },
  {
    start_time: "11:05AM",
    end_time: "11:15AM",
    activity: "Cultural Performance",
    type: "morning",
  },
  {
    start_time: "11:15AM",
    end_time: "11:40AM",
    activity: "Smartcomply Introduction",
    type: "morning",
  },
  {
    start_time: "11:40AM",
    end_time: "12:10AM",
    activity: "Awards & Recognitions",
    type: "morning",
  },
  {
    start_time: "12:10AM",
    end_time: "12:20AM",
    activity: "Closing Remarks",
    type: "morning",
  },
  {
    start_time: "12:20AM",
    end_time: "01:00PM",
    activity: "Networking",
    type: "afternoon",
  },
];
export const AGENDAS_FRENCH = [
  {
    start_time: "07:00AM",
    end_time: "07:45AM",
    activity: "Arrivée et inscription",
    type: "morning",
  },
  {
    start_time: "07:45AM",
    end_time: "07:50AM",
    activity: "Règles de la maison et sécurité",
    type: "morning",
  },
  {
    start_time: "07:50AM",
    end_time: "07:53AM",
    activity: "Hymne national",
    type: "morning",
  },
  {
    start_time: "07:53AM",
    end_time: "08:00AM",
    activity: "Discours d’ouverture",
    type: "morning",
  },
  {
    start_time: "08:00AM",
    end_time: "08:20AM",
    activity: "Discours principal 1 : L’horizon sécurisé",
    type: "morning",
  },
  {
    start_time: "08:20AM",
    end_time: "08:50AM",
    activity: "Discussion informelle (Fireside Chat)",
    type: "morning",
  },
  {
    start_time: "08:50AM",
    end_time: "09:00AM",
    activity: "Pause / Transition",
    type: "morning",
  },
  {
    start_time: "09:00AM",
    end_time: "09:40AM",
    activity: "Panel 1 : IA, finance en temps réel et confiance",
    type: "morning",
  },
  {
    start_time: "09:40AM",
    end_time: "10:00AM",
    activity: "Pause thé et réseautage",
    type: "morning",
  },
  {
    start_time: "10:00AM",
    end_time: "10:20AM",
    activity: "Discours principal 2 : Des données à la défense",
    type: "morning",
  },
  {
    start_time: "10:20AM",
    end_time: "10:25AM",
    activity: "Pause / Réinitialisation",
    type: "morning",
  },
  {
    start_time: "10:25AM",
    end_time: "11:05AM",
    activity: "Panel 2 : Présentation de l’étude + Panel de réactions",
    type: "morning",
  },
  {
    start_time: "11:05AM",
    end_time: "11:15AM",
    activity: "Prestation culturelle",
    type: "morning",
  },
  {
    start_time: "11:15AM",
    end_time: "11:40AM",
    activity: "Présentation de Smartcomply",
    type: "morning",
  },
  {
    start_time: "11:40AM",
    end_time: "12:10AM",
    activity: "Prix et reconnaissances",
    type: "morning",
  },
  {
    start_time: "12:10AM",
    end_time: "12:20AM",
    activity: "Discours de clôture",
    type: "morning",
  },
  {
    start_time: "12:20AM",
    end_time: "01:00PM",
    activity: "Réseautage",
    type: "afternoon",
  },
];

export const FAQS_ENGLISH = [
  {
    question: "Who should attend?",
    answer:
      "Senior leaders and operators in banking, mobile money, payments, fintech, insurance, retail, public sector, and critical infrastructure; policy and regulation stakeholders; security, risk, compliance, and technology teams.",
  },
  {
    question: "Is the breakfast conference free?",
    answer:
      "Attendance is by invitation or approved registration. Some seats may be complimentary, while others may be reserved for partners or sponsors.",
  },
  {
    question: "Will there be a live stream?",
    answer:
      "Select sessions may be recorded or shared post-event. Live streaming availability will be communicated to registered participants.",
  },
  {
    question: "How do I access the evening mixer?",
    answer:
      "Access to the mixer is limited and subject to availability. Eligible attendees will receive direct confirmation ahead of time.",
  },
  {
    question: "Can my company partner or sponsor?",
    answer:
      "Yes. Partnership and sponsorship opportunities are available for organizations aligned with the event’s focus and audience.",
  },
  {
    question: "Travel & venue details?",
    answer:
      "Confirmed venue information and logistical details will be shared directly with registered attendees.",
  },
  {
    question: "Accessibility & dietary needs?",
    answer:
      "Yes. Accessibility requirements and dietary preferences can be indicated during registration and will be accommodated where possible.",
  },
  {
    question: "How is my data handled?",
    answer:
      "All personal data is processed securely and in line with applicable data protection and privacy regulations.",
  },
];

export const FAQS_FRENCH = [
  {
    question: "Qui devrait assister ?",
    answer:
      "Les dirigeants et opérateurs seniors dans la banque, le mobile money, les paiements, la fintech, l’assurance, le commerce de détail, le secteur public et les infrastructures critiques ; les parties prenantes de la politique et de la régulation ; les équipes sécurité, risque, conformité et technologie.",
  },
  {
    question: "La conférence matinale est-elle gratuite ?",
    answer:
      "La participation se fait sur invitation ou via une inscription approuvée. Certains sièges peuvent être gratuits, tandis que d’autres sont réservés aux partenaires ou sponsors.",
  },
  {
    question: "Y aura-t-il un flux en direct ?",
    answer:
      "Certaines sessions peuvent être enregistrées ou partagées après l’événement. La disponibilité du streaming en direct sera communiquée aux participants inscrits.",
  },
  {
    question: "Comment accéder au cocktail du soir ?",
    answer:
      "L’accès au cocktail est limité et soumis à disponibilité. Les participants éligibles recevront une confirmation directe à l’avance.",
  },
  {
    question: "Mon entreprise peut-elle devenir partenaire ou sponsor ?",
    answer:
      "Oui. Des opportunités de partenariat et de sponsoring sont disponibles pour les organisations alignées avec le thème et le public de l’événement.",
  },
  {
    question: "Détails sur le voyage et le lieu ?",
    answer:
      "Les informations confirmées sur le lieu et la logistique seront communiquées directement aux participants inscrits.",
  },
  {
    question: "Accessibilité et besoins alimentaires ?",
    answer:
      "Oui. Les exigences d’accessibilité et les préférences alimentaires peuvent être indiquées lors de l’inscription et seront prises en compte autant que possible.",
  },
  {
    question: "Comment mes données sont-elles traitées ?",
    answer:
      "Toutes les données personnelles sont traitées de manière sécurisée et conformément aux réglementations applicables en matière de protection des données et de confidentialité.",
  },
];
